import React from 'react';
import { PageLayout } from '@BUP/components';
import { useAuth } from '@BUP/hooks';
import DataInstrumentsCounselor from '../instrumentsCounselor';
import DataInstrumentsTeacher from '../instrumentsTeacher';
import DataInstrumentsStudent from '../instrumentsStudent';
import './styles.css';

const DataInstrumentsPage = () => {
  const { user } = useAuth();
  // console.log('USER', user);

  const roleType = user?.roles?.type;

  switch (roleType) {
    case 'COUNSELOR':
      return (
        <PageLayout>
          <DataInstrumentsCounselor />
        </PageLayout>
      );
    case 'TEACHER':
      return (
        <PageLayout>
          <DataInstrumentsTeacher />
        </PageLayout>
      );
    case 'ASSISTANT':
      return (
        <PageLayout>
          <DataInstrumentsTeacher />
        </PageLayout>
      );
    case 'STUDENT':
      return (
        <PageLayout>
          <DataInstrumentsStudent />
        </PageLayout>
      );
    case 'PARENT':
      return (
        <PageLayout>
          <DataInstrumentsStudent />
        </PageLayout>
      );
    default:
      return null;
  }
};

export default DataInstrumentsPage;
